export default {
  itemFontSize: '12px',
  itemHeight: '36px',
  itemWidth: '52px',
  panelActionPadding: '8px 0'
};